import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalCard from "../../../../components/GlobalCardComponent";
import { useNavigate } from "react-router-dom";
import TestPrepSubserviceCards from "../../TestPrepSubserviceCards";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";

export default function TestPrepSubserviceComp({ subserviceCardData }) {
  const navigate = useNavigate();
  const [updatedData, setUpdatedData] = useState([]);
 

  useEffect(() => {
    if (subserviceCardData?.result) {
      const mappedData = subserviceCardData.result.map((item) => {
        let image = "";
        let color = "";

        switch (item?.name?.toUpperCase()) {
          case "GRE":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (2).png";
            color = "#214E33";
            break;
          case "GMAT":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (3).png";
            color = "#C11D53";
            break;
          case "DUOLINGO":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (4).png";
            color = "#3E1A85";
            break;
          case "TOEFL":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (5).png";
            color = "#EE5A24";
            break;
          case "PTE":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (6).png";
            color = "#17B6D8";
            break;
          case "SAT":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (7).png";
            color = "#EA3E76";
            break;
          case "IELTS":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (8).png";
            color = "#9607CD";
            break;
          case "SPOKEN ENGLISH":
            image = "/newdashboard/TestTypeImages/Group 1171282791 (3).png";
            color = "#C11D53 ";
            break;
          default:
            image = "/newdashboard/TestTypeImages/Group 1171282791 (3).png"; // fallback image
            break;
        }

        return { ...item, firstImage: image, color: color };
      });

      setUpdatedData(mappedData);
    }
  }, [subserviceCardData]);

  const handleViewdetails = (data) => {
       localStorage.setItem("testDetails", JSON.stringify(data));
    const url = `/test-prep/testinfo?test=${encodeURIComponent(data?.name)}`;
    window.open(url, "_blank"); // open in new tab
  
  };




  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} textAlign="center">
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "27px",
              fontWeight: 700,
              color: "#572575"
            }}
          >
            Top Global Exams
          </Typography>
          <Typography
            mt={1}
            sx={{
              fontFamily: "Inter",
              fontSize: "15px",
              fontWeight: 500,
              color: "#3F424C",
            }}
          >
           Prepare for internationally recognized tests that open doors to study and career opportunities.
          </Typography>
        </Grid>

        <Grid item xs={12} mt={4} mb={4}>
          <Grid container spacing={4}>
            {updatedData.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <CustomCardWithBorder  boxShadow={true}
                   hovershadowEffect={true}
                  onClick={() => handleViewdetails(item)}
                  cursor={true}
                >
                  <TestPrepSubserviceCards
                    firstImage={item?.firstImage}
                    title={item?.name}
                    subtitle={item?.description}
                    color={item?.color}
                  />
                </CustomCardWithBorder>
              </Grid>
            ))}

           
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
